<template>
  <div class="md:w-1/2 pb-0 md:pb-5 px-5 md:px-3 py-5 md:pl-10">
    <slot />
    <div class="product-gallery h-full relative">
      <!-- Positioned over the (main) image, e.g. a favorite button in its corner -->
      <slot name="overlay" />
      <Carousel v-if="_.get(variant, 'images.length', 0) > 1" :gallery="variant.images" :width="imageSize.width" :height="imageSize.height" />
      <div v-else class="w-full h-full flex items-start justify-center text-light">
        <Image
          :src="variant?.image?.url || _.get(variant, 'images.0.url', null) || siteSettings.product.placeholderImage[config.public.layoutDesign]"
          :alt="variant.name"
          :title="variant?.image?.description || _.get(variant, 'images.0.description', null) || variant.name"
          :width="imageSize.width"
          :height="imageSize.height"
          sizes="280px xs:588px sm:460px lg:588px"
          object-fit="cover"
          class="rounded"
          class-name="cursor-zoom-in bg-radial-gradient"
          @click="showImage"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
import _ from 'lodash-es';
import GLightbox from 'glightbox-ssr';
import { siteSettings } from "@settings/site.settings";
import Image from "@components/ui/image";
import Carousel from "@components/ui/carousel";

const props = defineProps({
  variant: {
    type: Object,
    default: () => { }
  },
  // { width, height } of the displayed image, also sets its ratio
  imageSize: {
    type: Object,
    default: () => ({ width: 768, height: 576 })
  }
})

const config = useRuntimeConfig();
const lightbox = GLightbox({ touchNavigation: true, selector: null });

const mapElements = (value) => _.map(_.filter(value, image => image?.url), image => _.assign({}, {
  href: image.url,
  type: 'image'
}, image?.description ? { description: image?.description } : {} ));

onMounted(() => {
  const image = props.variant?.image || _.get(props.variant, 'images.0', null);
  lightbox.setElements(mapElements(image ? [ image ] : []));
});

const showImage = () => lightbox.open();

</script>
